var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-lock",style:(_vm.styleCircle)},[_c('LockIcon',{attrs:{"width":_vm.variant.iconWidth,"height":_vm.variant.iconHeight}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }